// ==================== ROADMAP TEMPLATES ====================

export const ROADMAP_TEMPLATES = {
  phases: [
    {
      phase: 1,
      name: 'Foundation',
      duration: '0-3 months',
      focus: 'Build foundation',
      activities: [
        'Conduct AI readiness assessment',
        'Establish data governance',
        'Set up infrastructure',
        'Identify pilot use cases',
        'Build initial team'
      ],
      deliverables: [
        'AI Readiness Report',
        'Data Governance Policy',
        'Infrastructure Setup',
        'Use Case List'
      ],
      budgetAllocation: 0.20,
      successCriteria: ['Infrastructure ready', 'Team hired', 'Use cases identified']
    },
    {
      phase: 2,
      name: 'Pilot',
      duration: '3-6 months',
      focus: 'Prove value',
      activities: [
        'Implement pilot projects',
        'Measure impact',
        'Refine processes',
        'Build reusable components'
      ],
      deliverables: [
        'Pilot Results',
        'ROI Analysis',
        'MLOps Pipeline'
      ],
      budgetAllocation: 0.30,
      successCriteria: ['Pilot success', 'ROI demonstrated', 'Process established']
    },
    {
      phase: 3,
      name: 'Scale',
      duration: '6-12 months',
      focus: 'Scale successful pilots',
      activities: [
        'Scale use cases',
        'Automate pipelines',
        'Expand team',
        'Integrate with business'
      ],
      deliverables: [
        'Scaled Solutions',
        'Automated Pipelines',
        'AI Platform'
      ],
      budgetAllocation: 0.30,
      successCriteria: ['10+ use cases', 'Cost savings', 'Revenue impact']
    },
    {
      phase: 4,
      name: 'Optimize',
      duration: '12-24 months',
      focus: 'Continuous optimization',
      activities: [
        'Optimize models',
        'New use cases',
        'Transform processes',
        'Establish governance'
      ],
      deliverables: [
        'Optimized Models',
        'New Products',
        'Transformed Processes'
      ],
      budgetAllocation: 0.20,
      successCriteria: ['50% adoption', '30% cost reduction', '20% new revenue']
    }
  ],
  
  quickWins: [
    {
      initiative: 'Automated Reporting',
      impact: 'Save 20 hours/week',
      effort: 'Low',
      timeline: '4 weeks',
      value: 'High',
      complexity: 'Low',
      prerequisites: ['Data access', 'Reporting tools']
    },
    {
      initiative: 'Predictive Maintenance',
      impact: 'Reduce downtime 30%',
      effort: 'Medium',
      timeline: '8 weeks',
      value: 'High',
      complexity: 'Medium',
      prerequisites: ['Sensor data', 'Historical maintenance data']
    },
    {
      initiative: 'Customer Segmentation',
      impact: 'Increase conversion 15%',
      effort: 'Low',
      timeline: '6 weeks',
      value: 'High',
      complexity: 'Low',
      prerequisites: ['Customer data', 'Analytics tools']
    },
    {
      initiative: 'Chatbot for FAQs',
      impact: 'Reduce support tickets 40%',
      effort: 'Low',
      timeline: '4 weeks',
      value: 'Medium',
      complexity: 'Low',
      prerequisites: ['FAQ content', 'NLP model']
    },
    {
      initiative: 'Anomaly Detection',
      impact: 'Detect issues 90% faster',
      effort: 'Medium',
      timeline: '10 weeks',
      value: 'High',
      complexity: 'Medium',
      prerequisites: ['Historical data', 'ML model']
    }
  ]
};